@if (pageReady) {
  <main class="gs-page">
    <div class="cancel-autopay-container">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="notification-container">
        <app-notification [pageName]="pageName"></app-notification>
      </div>
      <div class="cancel-details">
        <div class="cancel-container">
          @if (showAutoPayChangeHeader) {
            <h2 class="cancel-label">{{ pageLabels.autoPayChangeText }}</h2>
            <p>{{ pageLabels.autoPayChangeConfirmationText }}</p>
          } @else {
            <h2 class="cancel-label">{{ pageLabels.autoPayCancelText }}</h2>
            <p>{{ pageLabels.autoPayCancelConfirmationText }}</p>
          }
        </div>
        <mat-divider></mat-divider>
        <div class="cta-container">
          @if (!hasEmail) {
            <div class="email-form pay-detail">
              <h2>{{ pageLabels.emailHeader }}</h2>
              <app-email-form [emailData]="emailFormData"></app-email-form>
              <p class="email-disclaimer">{{ pageLabels.emailDisclaimer }}</p>
            </div>
          }
          <a
            class="autopay-link"
            [attr.aria-label]="pageLabels.autoPayKeepAutopayLinkAriaLabel"
            [routerLink]="pageLabels.autoPayCancelKeepAutoPayLink"
            >{{ pageLabels.autoPayCancelKeepAutopayText }}</a
          >
          <button
            role="link"
            mat-flat-button
            color="primary"
            [attr.aria-label]="pageLabels.autoPayCancelButtonAriaLabel"
            class="gs-form-button-primary"
            (click)="cancelAutoPay()"
          >
            {{ pageLabels.autoPayCancelButtonText }}
          </button>
        </div>
      </div>
    </div>
  </main>
}
